'use strict';

angular.module('shiftTraderApp')
    .directive('saMiniDayViewPositionBar', function (PositioningService, saMiniDayViewShiftHeightInt) {
      return {
        templateUrl: 'views/directives/saMiniDayViewPositionBar.html',
        restrict: 'A',
        scope: {
          position: '=saMiniDayViewPositionBar',
          dept: '=department',
          shifts: '='
        },
        link: function postLink(scope, element, attrs, ctrl) {
          var saMiniDayViewPositionBar = element.find('.sa_mini_day_view_position_bar');

          scope.calculateHeight = function() {
            var positioningResults = PositioningService.calcWorkPeriodShiftRow(scope.shifts);
            _.each(positioningResults.rows, function(row, idx) {
              scope.shifts[idx]._miniTop = row * saMiniDayViewShiftHeightInt;
            });

            scope.position._height = positioningResults.numRows * saMiniDayViewShiftHeightInt;
            saMiniDayViewPositionBar.css('height',  scope.position._height + 12);
          };

          scope.calculateHeight();


          scope.$watch(function() {
            return _.pluck(scope.shifts, '_compId').join(',');
          }, function(newVal, oldVal) {
            if (newVal !== oldVal) {
              scope.calculateHeight();
            }
          });
        }
      };
    });
